import type { StoreV2Lang } from "./store-v2-locale.js";
import type { CatalogCountry } from "./country-browser-v2.js";
import { DEFAULT_COUNTRY_FILTER_MEANING } from "./country-browser-v2.js";
import { CountryFlagSvg } from "./country-flag-svg.js";
import { t } from "./store-v2-ui-copy.js";

export function CountryBrowserV2({
  lang,
  countries,
  onOpenCountry,
}: {
  lang: StoreV2Lang;
  countries: CatalogCountry[];
  onOpenCountry: (countryId: string) => void;
}) {
  return (
    <div className="sv2-body sv2-route-top" data-route-top="countries" data-testid="sv2-country-browser">
      <div className="sv2-section-title">{t(lang, "countries")}</div>
      <p className="sv2-muted" data-testid="country_filter_meaning" data-country-meaning={DEFAULT_COUNTRY_FILTER_MEANING}>
        {DEFAULT_COUNTRY_FILTER_MEANING === "cuisine_country"
          ? t(lang, "country_filter_meaning")
          : t(lang, "country_filter_meaning")}
      </p>
      <p className="sv2-muted sv2-country-meaning-hint">
        {lang === "en"
          ? "Browse by Asian cuisine / taste origin — not factory country of the brand."
          : "Перегляд за азійською кухнею / походженням смаку — не країна заводу бренду."}
      </p>
      <div className="sv2-country-grid">
        {countries.map((country) => (
          <button
            key={country.country_id}
            type="button"
            className="sv2-country-tile"
            data-testid="sv2-country-tile"
            data-country-id={country.country_id}
            data-country-meaning={country.meaning}
            aria-label={`${country.flagEmoji} ${lang === "en" ? country.labelEn : country.labelUk}`}
            onClick={() => onOpenCountry(country.country_id)}
          >
            <span className="sv2-country-flag-container" aria-hidden="true">
              {country.iso2 ? (
                <CountryFlagSvg iso2={country.iso2} className="sv2-country-flag-img" />
              ) : (
                <span className="sv2-country-flag">{country.flagEmoji}</span>
              )}
            </span>
            <strong>{lang === "en" ? country.labelEn : country.labelUk}</strong>
            <span>
              {country.productCount} {t(lang, "products")}
              {country.activeAvailabilityCount > 0
                ? ` · ${country.activeAvailabilityCount} ${t(lang, "active_in_stock")}`
                : ""}
            </span>
          </button>
        ))}
      </div>
      {countries.length === 0 ? (
        <div className="sv2-muted" data-testid="sv2-countries-loading">
          {lang === "en" ? "Loading countries…" : "Завантажуємо країни…"}
        </div>
      ) : null}
    </div>
  );
}
